import * as React from 'react';
import { Heading, Stack, Text } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import {
  ABN,
  AccountName,
  SuperChoice,
  SuperMemberNumber,
} from '@zap-onboard/api-client';
import { inputs } from '@zap-onboard/web-components';
import { InfoBox } from '../../../../InfoBox';
import { z } from '../../../../../helpers';

export const NoMemberNumberSchema = z.object({
  superChoiceType: z.enum(['COMPLETE_WITHOUT_MEMBER_NUMBER']),
  fundABN: z.valueObject(z.string(), ABN),
  fundSPINOrUSI: z.string().min(1, { message: 'USI is required' }),
  fundName: z.string().min(1, { message: 'Fund name is required' }),
});

export const getNoMemberNumberDefaultValues = (
  choice?: SuperChoice,
): Omit<z.infer<typeof NoMemberNumberSchema>, 'superChoiceType'> => {
  if (!choice || choice.value.type !== 'COMPLETE_WITHOUT_MEMBER_NUMBER') {
    return {
      fundABN: '',
      fundSPINOrUSI: '',
      fundName: '',
    };
  }

  return {
    fundABN: choice.value.fundABN.asJSON(),
    fundSPINOrUSI: choice.value.fundSPINOrUSI,
    fundName: choice.value.fundName,
  };
};

export const SuperChoiceNoMemberNumber: React.FC = () => {
  const { setValue } = useFormContext();

  return (
    <Stack spacing={4}>
      <Stack spacing={6}>
        <inputs.TextInput
          name="superChoice.fundName"
          label="Fund Name"
          placeholder="Fund ABN"
          isDisabled
        />

        <inputs.TextInput
          name="superChoice.fundABN"
          label="Fund ABN"
          placeholder="Fund ABN"
          isDisabled
        />

        <inputs.TextInput
          label="Fund USI"
          name="superChoice.fundSPINOrUSI"
          placeholder="Fund USI"
          isDisabled
        />
      </Stack>
    </Stack>
  );
};
